import { LinearProgress } from '@mui/material';
import Box from '@mui/material/Box';

export const FullscreenLoadingIndicator = () => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
      }}
    >
      <LinearProgress color="inherit" sx={{ maxWidth: 360, width: 1 }} />
    </Box>
  );
};
